module.exports = __webpack_public_path__ + "d1d14b4f9de43b3f1783aa526c368773.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2018/midyear/icons/awards-blue.png
// module id = 1878
// module chunks = 1